<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()" *ngIf="!currentUrl">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Aniversariantes' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content class="list-mini-content">
  <app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

  <div class="gradient-extendido" *ngIf="loaded">
    <ion-segment
      mode="ios"
      value="dia"
      [(ngModel)]="aniversarioTipo"
      (ionChange)="onSegmentChanged($event)"
      class="segment-gradient-title"
    >
      <ion-segment-button value="dia">
        <ion-label class="header">{{'Dia' | translate}}</ion-label>
      </ion-segment-button>

      <ion-segment-button value="mes">
        <ion-label class="header">{{'Mês' | translate}}</ion-label>
      </ion-segment-button>

      <ion-segment-button value="grupo" *ngIf="!notFound">
        <ion-label class="header">{{'grupos' | nomenclatura | async}}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>

  <div [ngSwitch]="aniversarioTipo" *ngIf="loaded">
    <ion-row>
      <ion-col size="8" class="chip-col">
        <ng-container *ngIf="idInstituicaoFiltro !== idInstituicaoLogada">
          <ion-chip class="custom-chip" (click)="limparInstituicao()">
            <ion-label class="chip-label"> {{ nomeInstituicao }} </ion-label>

            <i class="fa-regular fa-xmark-large chip-close-icon"></i>
          </ion-chip>
        </ng-container>
      </ion-col>
    </ion-row>

    <div *ngSwitchCase="'dia'">
      <ion-list *ngFor="let aniversariante of aniversariantes;">
        <ion-item (click)="openModal(aniversariante);" lines="none" style="border-bottom: solid 1px #d7d7d7">
          <ion-avatar slot="start">
            <img
              [src]="((aniversariante.foto && aniversariante.foto) ? aniversariante.foto : '') | image:' '"
              class="avatar-image"
            />
          </ion-avatar>

          <ion-label>
            <ion-col>
              <h3 class="item-title">{{aniversariante.nome}}</h3>

              <p [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">
                {{'Tipo: ' | translate}} {{aniversariante.texto}}
              </p>

              <p [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">{{aniversariante.tipoM}}</p>
            </ion-col>
          </ion-label>

          <ion-note slot="end" [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">
            <i class="fa-solid fa-chevron-right icon-list"></i>
          </ion-note>
        </ion-item>
      </ion-list>
      <sem-registro [text]="'Nenhum Aniversariante encontrado'" [hidden]="aniversariantes.length"></sem-registro>
    </div>

    <div *ngSwitchCase="'mes'">
      <ion-list *ngFor="let aniversarianteMes of aniversariantesMes;">
        <ion-item (click)="openModal(aniversarianteMes);" lines="none" style="border-bottom: solid 1px #d7d7d7">
          <ion-avatar slot="start">
            <img
              [src]="((aniversarianteMes.foto && aniversarianteMes.foto) ? aniversarianteMes.foto : '') | image:' '"
              class="avatar-image"
            />
          </ion-avatar>

          <ion-label>
            <ion-col>
              <h3 class="item-title">{{aniversarianteMes.nome}}</h3>

              <p>
                {{aniversarianteMes.nascimento | dateFormat:"dd"}} {{'de' | translate}} {{aniversarianteMes.nascimento |
                dateFormat:'MMMM'}}
              </p>

              <p [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">
                {{'Tipo: ' | translate}} {{aniversarianteMes.texto}}
              </p>

              <p [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">{{aniversarianteMes.tipoM}}</p>
            </ion-col>
          </ion-label>

          <ion-note slot="end" [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">
            <i class="fa-solid fa-chevron-right icon-list"></i>
          </ion-note>
        </ion-item>
      </ion-list>

      <sem-registro [text]="'Nenhum Aniversariante encontrado'" [hidden]="aniversariantesMes.length"></sem-registro>
    </div>

    <div *ngSwitchCase="'grupo'">
      <div class="list-mini" [hidden]="!listGrupo">
        <ion-grid>
          <ion-row>
            <ion-col size="12">
              <ion-button class="btn-default" expand="block" id="open-modal" (click)="selectGrupo()">
                {{'Selecionar ' | translate}} {{'grupo' | nomenclatura | async}}
              </ion-button>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col>
              <ion-item lines="none">
                <ion-toggle [enableOnOffLabels]="true" [checked]="toogle" (ionChange)="setConfig()">
                  {{'Aniversariantes do ' | translate}}{{periodo}}
                </ion-toggle>
              </ion-item>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="8" class="chip-col">
              <ng-container *ngIf="grupoSelecionado">
                <ion-chip class="custom-chip" (click)="changeVincular()">
                  <ion-label class="chip-label"> {{ grupoSelecionado }} </ion-label>

                  <i class="fa-regular fa-xmark-large chip-close-icon"></i>
                </ion-chip>
              </ng-container>
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-list *ngFor="let grupo of listGrupo;">
          <ion-item (click)="openModalGrupo(grupo);" lines="none" style="border-bottom: solid 1px #d7d7d7">
            <ion-avatar slot="start">
              <img [src]="((grupo.foto && grupo.foto) ? grupo.foto : '') | image:' '" class="avatar-image" />
            </ion-avatar>

            <ion-label>
              <ion-col>
                <h3 class="item-title">{{grupo.pessoa}}</h3>

                <p>
                  {{grupo.nascimento | dateFormat:'dd'}} {{'de' | translate}} {{grupo.nascimento | dateFormat:'MMMM'}}
                </p>

                <p class="nomenclatura">{{'grupo' | nomenclatura | async}} - {{grupo.nome}}</p>

                <p [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">
                  {{'Tipo: ' | translate}} {{grupo.texto}}
                </p>

                <p [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">{{grupo.tipoM}}</p>
              </ion-col>
            </ion-label>

            <ion-note slot="end" [hidden]="!userProvider.hasPermissao('PESSOA_VISUALIZAR')">
              <i class="fa-solid fa-chevron-right icon-list"></i>
            </ion-note>
          </ion-item>
        </ion-list>
      </div>

      <ion-modal #modal trigger="open-modal">
        <ng-template>
          <ion-header class="extendido">
            <ion-buttons>
              <ion-button (click)="modal.dismiss()">
                <i class="fa-regular fa-chevron-left chevron-back-button"></i>
              </ion-button>

              <ion-title>{{'Fechar' | translate}}</ion-title>
            </ion-buttons>
          </ion-header>

          <ion-content>
            <div class="gradient-extendido" style="height: 30px"></div>
            <ion-grid>
              <ion-row>
                <ion-col>
                  <ion-searchbar
                    class="custom"
                    show-cancel-button="never"
                    (ionClear)="onCancel()"
                    [placeholder]="('Buscar' | translate)"
                    [(ngModel)]="filtro.q"
                    (ionInput)="onInput()"
                  >
                  </ion-searchbar>
                </ion-col>
              </ion-row>

              <ion-row *ngFor="let grupo of gruposList;">
                <ion-col (click)="selecionar(grupo, true);">
                  <ion-item>
                    <ion-note slot="start">
                      <i class="fas fa-place-of-worship icon-list"></i>
                    </ion-note>

                    <ion-label>
                      <div>
                        <h3>{{grupo.nome}}</h3>
                      </div>
                    </ion-label>
                  </ion-item>
                </ion-col>
              </ion-row>
            </ion-grid>

            <ion-infinite-scroll
              (ionInfinite)="loadGrupos($event)"
              *ngIf="pagination.currentPage < pagination.pageCount"
              threshold="100px"
            >
              <ion-infinite-scroll-content loadingSpinner="bubbles"> </ion-infinite-scroll-content>
            </ion-infinite-scroll>
          </ion-content>
        </ng-template>
      </ion-modal>

      <sem-registro [text]="'Nenhum Aniversariante encontrado'" [hidden]="listGrupo"></sem-registro>
    </div>
  </div>

  <ion-fab slot="fixed" vertical="bottom" horizontal="end" *ngIf="userProvider.hasPermissao('PESSOA_VISUALIZAR_ANIVERSARIANTES') && loaded">
    <ion-fab-button (click)="showFilterInstituicao()" class="btn-filtro-instituicao">
      <i class="fa-solid fa-place-of-worship"></i>
    </ion-fab-button>
  </ion-fab>
</ion-content>
